// redux/constants/expenseConstants.js
export const EXPENSE_DETAILS_REQUEST = 'EXPENSE_DETAILS_REQUEST';
export const EXPENSE_DETAILS_SUCCESS = 'EXPENSE_DETAILS_SUCCESS';
export const EXPENSE_DETAILS_FAIL = 'EXPENSE_DETAILS_FAIL';

export const FETCH_EXPENSES_REQUEST = 'FETCH_EXPENSES_REQUEST';
export const FETCH_EXPENSES_SUCCESS = 'FETCH_EXPENSES_SUCCESS';
export const FETCH_EXPENSES_FAIL = 'FETCH_EXPENSES_FAIL';

export const CREATE_EXPENSE_SUCCESS = 'CREATE_EXPENSE_SUCCESS';
export const CREATE_EXPENSE_FAIL = 'CREATE_EXPENSE_FAIL';

export const UPDATE_EXPENSE_SUCCESS = 'UPDATE_EXPENSE_SUCCESS';
export const UPDATE_EXPENSE_FAIL = 'UPDATE_EXPENSE_FAIL';

export const DELETE_EXPENSE_SUCCESS = 'DELETE_EXPENSE_SUCCESS';
export const DELETE_EXPENSE_FAIL = 'DELETE_EXPENSE_FAIL';
